import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConfigService } from "@tmhcc-ng-lib/global-services";
import { AppConfig } from "@tmhcc-ng-lib/models";
import { Observable } from "rxjs/internal/Observable";
import { HttpOptions, BaseHttpService } from "@tmhcc-ng-lib/framwork/http";

export abstract class BaseDataService extends BaseHttpService {
  protected config: AppConfig;
  protected serviceBaseUrl: string;
  protected dwldServiceBaseUrl: string;
  protected policyDownloadServiceBaseUrl: string;
  protected token: any;

  //Kidnap & Ransom
  protected knrServiceBaseUrl : string;  
  protected knrServiceAPIKey : string;

  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http);

    this.config = configService.config;
    this.serviceBaseUrl = this.config.dataServiceBaseUrl;
    this.dwldServiceBaseUrl = this.config.policyListServiceBaseUrl;
    this.policyDownloadServiceBaseUrl = this.config.policyDownloadServiceBaseUrl;

    this.token = JSON.parse(localStorage.getItem('okta-token-storage'));

    //Kidnap & Ransom
    this.knrServiceBaseUrl = this.config.knrServiceBaseUrl;    
    this.knrServiceAPIKey = this.config.knrServiceAPIKey;
  }

  protected get<T>(url: string, options?: HttpOptions): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendDefaultHeaders(options.headers);

    return this.http.get<T>(url, options);
  }

  protected post<T>(url: string, options?: HttpOptions): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendDefaultHeaders(options.headers);

    return this.http.post<T>(url, options.body, {
      params: options.params,
      headers: options.headers
    });
  }

  protected put<T>(url: string, options?: HttpOptions): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendDefaultHeaders(options.headers);

    return this.http.put<T>(url, options.body, {
      params: options.params,
      headers: options.headers
    });
  }

  private appendDefaultHeaders(headers?: HttpHeaders): HttpHeaders {
    if (!headers) {
      headers = new HttpHeaders();
    }

    return headers
      .set("x-api-key", this.config.dataServiceApiKey)
      .set("content-type", "application/json")
      .set('Authorization', 'Bearer ' + this.token.accessToken.accessToken);
  }

  protected postv1<T>(url: string, options?: HttpOptions, serviceapikey?: string): Observable<T> {
    if (!options) options = {};
    options.headers = this.appendDwldHeaders(options.headers,serviceapikey);
    return this.http.post<T>(url, options.body, {
      params: options.params,
      headers: options.headers
    });
  }

  protected postv2<T>(url: string, options?: HttpOptions) {
    if (!options) options = {};
    options.headers = this.appendDwldHeaders(options.headers);
    return this.http.post<any>(url, options.body, {
      params: options.params,
      headers: options.headers
    }).toPromise();
  }

  private appendDwldHeaders(headers?: HttpHeaders,serviceapikey? : string): HttpHeaders {
    if (!headers) {
      headers = new HttpHeaders();
    }
    
    return headers
      .set("x-api-key", serviceapikey)
      .set("Content-Type", "application/json")      
      .set('Authorization', 'Bearer ' + this.token.accessToken.accessToken);
   }
}
